import { useEffect } from 'react';
import { saveLocalNDBFlow } from '@/helpers/NDBFlow';
import { STORAGE, useGetCommonStore, useLocalStorageStore } from '@/store';
import { NDB_LANDINGS_LIST } from '../helpers/common';

export interface INDBLandingCode {
  initialCode: string;
  coupon: string;
}

export const useLandingNDBFlow = (
  name: string,
  promocodeFromQuery?: string | null
) => {
  const user = useGetCommonStore().use.user();

  useEffect(() => {
    const isNDBFlow = NDB_LANDINGS_LIST.has(name);

    saveLocalNDBFlow({ isNDBFlow });

    if (isNDBFlow && !user) {
      useLocalStorageStore.getState().replace(
        STORAGE.NDB_LANDING_CODE,
        JSON.stringify({
          initialCode: name, // Used for identifying visited promo page
          coupon: promocodeFromQuery || name,
        })
      );
    }
  }, [name, promocodeFromQuery, user]);
};
